/**
 * Personal Shadow AI Stats contract.
 *
 * The three summary cards on the personal Shadow AI page, computed server-side.
 * Scope is the requesting user, org-agnostic. Unlike the org stats object, this
 * carries only the fields the personal page renders.
 */
import { z } from 'zod';
export const personalShadowAiStatsSchema = z.object({
    runningNow: z.number().int().min(0),
    installedTools: z.number().int().min(0),
    browserTools: z.number().int().min(0),
});
//# sourceMappingURL=account-shadow-ai-stats.js.map